<template>
    <span v-html="htmlStr" @click="triggerElClick($event)"></span>
</template>
<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    export default {
        name: 'swb-html-wrapper',
        desc: 'html包装器（可触发函数）',
        props: {
            html: {
                default: ''
            },
            data: null,
            //
            handler: {//(name, data, srcElement, evnt) 单击按钮、链接、图片 触发 等
                type: Function,
                default: null
            },
            handlerX: {//(srcElement) 单击按钮、链接、图片 触发 等 之外
                type: Function,
                default: null
            },
            onRendered: {
                type: Function,
                default: null
            }
        },
        data: function () {
            return {
                htmlStr: ''
            };
        },
        created() {
            this.setHtmlStr();
        },
        mounted() {
            if(this.onRendered) {
                this.onRendered();
            }
        },
        beforeDestroy() {
            this.onRendered = null;
            this.handlerX = null;
            this.handler = null;
            this.data = null;
            this.html = null;
        },
        updated() {
            if(this.onRendered) {
                this.onRendered();
            }
        },
        watch: {
            html(newVal, oldVal) {
                this.setHtmlStr();
            }
        },
        methods: {
            setHtmlStr() {
                this.htmlStr = this.html == null ? '' : (this.html + '');
            },
            getHtmlData() {
                return this.data || {};
            },
            triggerElClick(evnt) {
                //console.log(evnt);
                let srcElement = evnt.srcElement;
                let srcTagName = srcElement.tagName;
                let srcName = srcElement.name || null;
                let useClick = srcElement.getAttribute('use-click');
                if(useClick == null) {
                    useClick = srcElement.getAttribute('useclick');
                }
                useClick = useClick != null && useClick != 'false';
                //
                let clickValid = false;
                if(srcTagName == 'BUTTON' || srcTagName == 'A' || (srcTagName == 'INPUT' && srcElement.type == 'BUTTON') || useClick) {
                    clickValid = true;
                    //
                    if(typeof this.handler == 'function') {
                        this.handler(srcName, this.getHtmlData(), srcElement, evnt);
                    }
                }
                else if(srcTagName == 'IMG') {
                    let srcParent = srcElement.parentNode;
                    if(srcParent != null && (srcParent.tagName == 'A' || srcParent.tagName == 'BUTTON')) {
                        clickValid = true;
                        //
                        try {//如果是图片则触发为A或BUTTON的父元素的点击事件
                            if(!srcParent.disabled) {
                                srcParent.click();
                            }
                        }
                        catch(ex) {
                            //
                        }
                    }
                }
                //
                if(!clickValid) {
                    if(typeof this.handlerX == 'function') {
                        this.handlerX(srcElement);
                    }
                }
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/ctrl/HtmlWrapper.vue